class ProductDetailReferences extends Component {
    constructor(el) {
        super(el);
        this.swiperElem = this.$find('[data-product-detail-references-swiper]');
        this.swiperElem && this.constructSwiper();
    }

    constructSwiper() {
        const swiper = new Swiper(this.swiperElem, {
            watchOverflow: true,
            loop: false,
            autoplay: {
                delay: 4000,
            },
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: '.ProductDetailReferences-next',
                prevEl: '.ProductDetailReferences-prev',
            },
        });
    }
}
